import { Select } from 'antd';
import debounce from 'lodash/debounce';
import React from 'react';
import NotFoundContentLoading from './NotFoundContentLoading';

const CustomAutocomplete = ({
  fetchOptions,
  debounceTimeout = 800,
  mapOptions,
  onError,
  renderOptions,
  style,
  ...props
}) => {
  const [fetching, setFetching] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const fetchRef = React.useRef(0);
  const loadOptions = React.useCallback(
    (value) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;
      setOptions([]);
      setFetching(true);
      fetchOptions(value)
        .then((newOptions) => {
          if (fetchId !== fetchRef.current) {
            // for fetch callback order
            return;
          }

          if (newOptions?.data?.data?.rows) {
            setOptions(newOptions.data.data.rows.map(mapOptions));
          }
          setFetching(false);
        })
        .catch((error) => {
          setFetching(false);
          if (onError) onError(error);
        });
    },
    [fetchOptions, mapOptions, onError]
  );

  const debounceFetcher = React.useMemo(() => {
    return debounce(loadOptions, debounceTimeout);
  }, [debounceTimeout, loadOptions]);
  return (
    <Select
      showSearch
      allowClear
      labelInValue
      filterOption={false}
      onSearch={debounceFetcher}
      loading={fetching}
      notFoundContent={<NotFoundContentLoading loading={fetching} />}
      style={{
        width: '100%',
        ...style
      }}
      {...props}
      onClear={() => loadOptions('')}
      onFocus={() => options.length === 0 && loadOptions('')}
      options={!renderOptions ? options : undefined}
      onSelect={(value) => {
        if (props.onSelect) {
          return props.onSelect(value, options);
        }
        return value;
      }}
    >
      {renderOptions && renderOptions(options)}
    </Select>
  );
};

export default CustomAutocomplete;
